/**
 * Traverses up the DOM tree from the given node to find the nearest ancestor element
 * that is scrollable (i.e., its scrollHeight exceeds its clientHeight).
 *
 * @param node - The starting DOM element, or `null`/`undefined`.
 * @returns The nearest scrollable ancestor element, or `document.documentElement` if none is found.
 */
export function getScrollContainer(node: Element | null | undefined): Element {
  while ((node = node?.parentElement)) {
    if (node.scrollHeight > node.clientHeight) {
      return node;
    }
  }

  return document.documentElement;
}
